// NewCategory.js
import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import './NewCategory.css';
import { baseUrl } from '../components/constant';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Ensure toastify styles are imported
import Select from 'react-select';
const NewNotifcation = () => {
  const [Title, setTitle] = useState('');
  const [Description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const options = []

  const navigate = useNavigate();

 

  useEffect(() => {
  }, []);


  const handleSave = async (e) => {
    e.preventDefault();
    setError('')
   

    if (!Title) {
      toast.error('Please enter Notification Title');
      return;
    }
    if (!Title) {
      toast.error('Please enter Notification Description');
      return;
    }
  
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (!token) {
        toast.error('You are not authenticated.');
        return;
      }
      const formData = new FormData();
      formData.append('title[ar]', Title);
      formData.append('title[en]', Title);
      formData.append('body[ar]', Description);
      formData.append('body[en]', Description);
      const response = await fetch(baseUrl + '/notifications/broadcast', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success('Notitcation sent successfully');
        navigate('/Notifications');// Redirect to the home page within the root layout
      } else {
        if (data.errors) {
          if (data.errors.name) {
            toast.error(data.errors.name[0]);
          }
        }
      }
    } catch (err) {
      console.log("err", err)
      // Handle network or unexpected errors
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };



  return (
    <div style={{ width: '100%', justifyContent: "center" }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}


      <h2 style={{ color: "#000", textAlign: 'center' }}>New Notification</h2>

     


      <div className="new-category-container">
        <div className="new-category">


          <div className="new-form-group">
            <label htmlFor="name">Title</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "80%", color: "#000" }}
              placeholder='Title'
              required
              type="text"
              id="name"
              value={Title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="new-form-group">
            <label htmlFor="Description">Description</label>
            <input
              style={{ backgroundColor: "#fff", fontSize: 20, width: "80%", color: "#000" }}
              placeholder='Description'
              required
              type="text"
              id="Description"
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

       
<div style={{height:'20px'}}></div>

        
        
          <div className="form-buttons">
            <button onClick={handleSave} style={{ backgroundColor: "rgb(154, 57, 57)" }}>Save</button>
            <button onClick={() => navigate('/Notifications')} style={{ backgroundColor: "#000" }}>Cancel</button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default NewNotifcation;
